import { KeyAndScale } from '@arpeggi/shared'
import { FC, useEffect, useMemo, useState } from 'react'
import { IArpMedia } from '../../../../features/arp-registry/ArpMedia'
import ArpRegistry from '../../../../features/arp-registry/ArpRegistry'
import { deserializeStemFromStorage } from '../../../stores/song/stem/StemUtils'
import { formatEpochTimestamp } from '../../core/helpers/dates'
import {
  CurrentlyPlayingMediaInfo,
  InfoRow,
  ProfileCurrentlyPlayingTabs
} from './ProfileCurrentlyPlaying'

interface Props {
  stem: IArpMedia
}

const CurrentlyPlayingStemProperties: FC<Props> = ({ stem }) => {
  const arp = useMemo(() => {
    return deserializeStemFromStorage(stem.metadata.arpeggiComposition)
  }, [stem])
  const createTime = stem.createdAt && parseInt(stem.createdAt)
  const keyAndScale = new KeyAndScale()
  keyAndScale.fromInt(stem.metadata.key)
  return (
    <>
      <InfoRow title="Original BPM">{stem.metadata.bpm}</InfoRow>
      {stem.metadata.genres[0] && <InfoRow title="Genre">{stem.metadata.genres[0]}</InfoRow>}
      <InfoRow title="Key">{keyAndScale.displayName()}</InfoRow>
      <InfoRow title="Mint Date">{formatEpochTimestamp(createTime)}</InfoRow>
    </>
  )
}

const CurrentlyPlayingStemOverview: FC<Props> = ({ stem }) => {
  return (
    <>
      <InfoRow title="Artist">{stem.user.displayName}</InfoRow>
      <InfoRow title="Contract Address">{stem.contractAddress}</InfoRow>
      <InfoRow title="Token ID">{stem.tokenId}</InfoRow>
      <InfoRow title="Blockchain">Polygon</InfoRow>
    </>
  )
}

const CurrentlyPlayingStemInfo: FC<CurrentlyPlayingMediaInfo> = ({ tab, index }) => {
  const [stem, setStem] = useState<IArpMedia>(null)

  useEffect(() => {
    ArpRegistry.getByIdAsync(index).then((data) => setStem(data))
  }, [index])

  return (
    <>
      {tab === ProfileCurrentlyPlayingTabs.OVERVIEW && stem && (
        <CurrentlyPlayingStemOverview stem={stem} />
      )}
      {tab === ProfileCurrentlyPlayingTabs.PROPERTIES && stem && (
        <CurrentlyPlayingStemProperties stem={stem} />
      )}
    </>
  )
}

export default CurrentlyPlayingStemInfo
